import * as React from 'react';
import { ThemeProvider as Provider } from 'emotion-theming';
import alertVariants from './Alert/Alert.variants';
import avatarVariants from './Avatar/Avatar.variants';
import buttonVariants from './Button/Button.variants';
import checkboxVariants from './Checkbox/Checkbox.variants';
import headingVariants from './Heading/Heading.variants';
import messageBubbleVariants from './MessageBubble/MessageBubble.variants';
import optionVariants from './Option/Option.variants';
import separatorVariants from './Separator/Separator.variants';
import tableVariants from './Table/Table.variants';
import textVariants from './Text/Text.variants';
var variants = {
    alert: alertVariants,
    avatar: avatarVariants,
    checkbox: checkboxVariants,
    messageBubble: messageBubbleVariants,
    separator: separatorVariants,
    table: tableVariants,
};
var buttons = {
    button: buttonVariants,
    option: optionVariants,
};
var text = {
    heading: headingVariants,
    text: textVariants,
};
var fontSizes = [11, 12, 13, 14, 16, 20, 24, 32, 48, 64, 72];
var space = [0, 4, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 128, 256, 512];
var letterSpacings = [0.6, 0.7, 0.9, 1.4];
var heights = [32, 40, 48, 56, 64];
var lineHeights = {
    large: '36px',
    big: '24px',
    normal: '20px',
    small: '16px',
    tight: '12px',
};
var breakpoints = ['0', '500px', '800px', '1200px', '1900px'];
var fontWeights = [400, 700];
var colours = {
    // Maybe rename colors later
    primary_1: '#4A3DD4',
    primary_2: '#574AE2',
    primary_3: '#6C5EF9',
    primary_4: '#DDDCF6',
    neutral_0: '#FFFFFF',
    neutral_1: '#F6F7FB',
    neutral_2: '#F2F4FA',
    neutral_3: '#ECEFF7',
    neutral_4: '#DDE2EF',
    neutral_5: '#CED5E7',
    neutral_6: '#979FB4',
    neutral_7: '#2C3951',
    neutral_8: '#252D40',
    secondary_1: '#972422',
    secondary_2: '#C6423F',
    secondary_3: '#E85653',
    secondary_4: '#F8CBCA',
    orange_1: '#EB9015',
    orange_2: '#FF9F1C',
    orange_3: '#F8DEBB',
    yellow_1: '#E4B912',
    yellow_2: '#FFD121',
    yellow_3: '#FBF2D1',
    green_1: '#48A9A6',
    green_2: '#4DD6D2',
    green_3: '#D6EBEA',
    blue_1: '#3158D6',
    blue_2: '#446FF8',
    blue_3: '#D0E3FC',
    cyan_1: '#4DD6D2',
    cyan_2: '#87E5E2',
    cyan_3: '#DEFBFA',
    dark_1: '#2C3951',
    dark_2: '#263146',
    // Remove old colours gradually
    grey: '#dde2ef',
    black: '#333333',
    white: '#ffffff',
    active: '#e6f7ff',
};
// We can get rid of gradients by generating them from two of the existing colours
var gradients = {
    primary_1: 'linear-gradient(56deg, rgba(113, 22, 208, 0.95), #4e61e1)',
};
export var theme = {
    breakpoints: breakpoints,
    colors: colours,
    colours: colours,
    fontSizes: fontSizes,
    fontWeights: fontWeights,
    gradients: gradients,
    heights: heights,
    letterSpacings: letterSpacings,
    lineHeights: lineHeights,
    space: space,
    fonts: {
        mono: '"IBM Plex Mono", "Courier New", Courier, monospace',
        sansSerif: '"Lato", -apple-system, BlinkMacSystemFont, "avenir next", avenir, "helvetica neue", helvetica, ubuntu, roboto, noto, "segoe ui", arial, sans-serif',
    },
    active: {
        background: colours.active,
    },
    radii: {
        tiny: '2px',
        small: '4px',
        normal: '8px',
        large: '16px',
    },
    actions: {
        default: {
            color: colours.neutral_6,
        },
        incorrect: {
            color: colours.neutral_6,
            textDecoration: 'line-through',
        },
        correct: {
            color: colours.primary_2,
            fontWeight: fontWeights[1],
        },
    },
    shadows: {
        sm: '0 6px 21px 0 rgba(152, 152, 152, 0.06)',
        md: '0 3px 6px 0 rgba(96,97,149,0.20)',
        lg: '0 11px 43px 0 rgba(120, 119, 150, 0.1)',
        selectBox: "0 2px 8px 0 " + colours.neutral_5,
        card: '0 2px 4px 0 rgba(207, 207, 207, 0.21)',
        button: '0 2px 4px 0 rgba(207, 207, 207, 0.67)',
        pageTitle: "0 2px 6px 0 " + colours.neutral_3,
    },
    menuItem: {
        default: {
            color: colours.neutral_6,
            backgroundColor: 'transparent',
            '&:hover': {
                color: colours.neutral_0,
                backgroundColor: colours.dark_2,
            },
        },
    },
    text: text,
    buttons: buttons,
    variants: variants,
};
var ThemeProvider = function (_a) {
    var children = _a.children;
    return React.createElement(Provider, { theme: theme }, children);
};
export default ThemeProvider;
